import * as Types from '../../../../gql/__generated/graphql.types';

import { SeoMetaDataFragment } from '../../../common/gql/__generated/seoMetadata.generated';
import { SeoMetaDataFragmentDoc } from '../../../common/gql/__generated/seoMetadata.generated';
import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { graphqlFetcher } from '@/modules/common/services/graphqlFetcher';
export type CollapsibleSectionFieldsFragment = (
  { __typename?: 'CollapsibleSection' }
  & Pick<Types.CollapsibleSection, 'title'>
  & { content?: Types.Maybe<(
    { __typename?: 'CollapsibleSectionContent' }
    & Pick<Types.CollapsibleSectionContent, 'json'>
  )> }
);

export type CollectionCollectionQueryVariables = Types.Exact<{
  slug?: Types.InputMaybe<Types.Scalars['String']['input']>;
  preview?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
}>;


export type CollectionCollectionQuery = (
  { __typename?: 'Query' }
  & { collectionCollection?: Types.Maybe<(
    { __typename?: 'CollectionCollection' }
    & CollectionFieldsFragment
  )> }
);

export type CollectionTypeQueryVariables = Types.Exact<{
  slug?: Types.InputMaybe<Types.Scalars['String']['input']>;
  preview?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
}>;


export type CollectionTypeQuery = (
  { __typename?: 'Query' }
  & { collectionCollection?: Types.Maybe<(
    { __typename?: 'CollectionCollection' }
    & { items: Array<Types.Maybe<(
      { __typename?: 'Collection' }
      & Pick<Types.Collection, 'collectionType'>
    )>> }
  )> }
);

export type CollectionCollectionSeoQueryVariables = Types.Exact<{
  slug?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type CollectionCollectionSeoQuery = (
  { __typename?: 'Query' }
  & { collectionCollection?: Types.Maybe<(
    { __typename?: 'CollectionCollection' }
    & { items: Array<Types.Maybe<(
      { __typename?: 'Collection' }
      & Pick<Types.Collection, 'collectionName' | 'description' | 'collectionType' | 'products'>
      & { contentfulMetadata: (
        { __typename?: 'ContentfulMetadata' }
        & { tags: Array<Types.Maybe<(
          { __typename?: 'ContentfulTag' }
          & Pick<Types.ContentfulTag, 'name'>
        )>> }
      ), newBaseImage?: Types.Maybe<(
        { __typename?: 'ContentfullAsset' }
        & Pick<Types.ContentfullAsset, 'url' | 'title' | 'width' | 'height'>
      )>, seo?: Types.Maybe<(
        { __typename?: 'SeoMetadata' }
        & SeoMetaDataFragment
      )> }
    )>> }
  )> }
);

export type CollectionFieldsFragment = (
  { __typename?: 'CollectionCollection' }
  & Pick<Types.CollectionCollection, 'total'>
  & { items: Array<Types.Maybe<(
    { __typename: 'Collection' }
    & Pick<Types.Collection, 'collectionName' | 'collectionType' | 'description' | 'products' | 'slug' | 'baseImage' | 'exactMatches' | 'roomType' | 'roomStyle' | 'colors' | 'designTipsTitle' | 'designPicksTitle' | 'photographer'>
    & { sys: (
      { __typename?: 'Sys' }
      & Pick<Types.Sys, 'id'>
    ), newBaseImage?: Types.Maybe<(
      { __typename?: 'ContentfullAsset' }
      & Pick<Types.ContentfullAsset, 'url' | 'title' | 'width' | 'height'>
    )>, designTipsListCollection?: Types.Maybe<(
      { __typename?: 'CollectionDesignTipsListCollection' }
      & { items: Array<Types.Maybe<(
        { __typename?: 'CollapsibleSection' }
        & CollapsibleSectionFieldsFragment
      )>> }
    )>, designer?: Types.Maybe<(
      { __typename?: 'Designer' }
      & Pick<Types.Designer, 'name'>
      & { sys: (
        { __typename?: 'Sys' }
        & Pick<Types.Sys, 'id'>
      ) }
    )> }
  )>> }
);

export type CollectionSitemapQueryVariables = Types.Exact<{
  skip?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  limit?: Types.InputMaybe<Types.Scalars['Int']['input']>;
}>;


export type CollectionSitemapQuery = (
  { __typename?: 'Query' }
  & { collectionCollection?: Types.Maybe<(
    { __typename?: 'CollectionCollection' }
    & Pick<Types.CollectionCollection, 'total'>
    & { items: Array<Types.Maybe<(
      { __typename?: 'Collection' }
      & Pick<Types.Collection, 'slug' | 'publishedDate'>
    )>> }
  )> }
);

export type PdpCollectionWithSkusQueryVariables = Types.Exact<{
  skus?: Types.InputMaybe<Array<Types.InputMaybe<Types.Scalars['String']['input']>> | Types.InputMaybe<Types.Scalars['String']['input']>>;
}>;


export type PdpCollectionWithSkusQuery = (
  { __typename?: 'Query' }
  & { collectionCollection?: Types.Maybe<(
    { __typename?: 'CollectionCollection' }
    & { items: Array<Types.Maybe<(
      { __typename?: 'Collection' }
      & Pick<Types.Collection, 'collectionName' | 'slug' | 'products'>
      & { newBaseImage?: Types.Maybe<(
        { __typename?: 'ContentfullAsset' }
        & Pick<Types.ContentfullAsset, 'url' | 'title' | 'width' | 'height'>
      )> }
    )>> }
  )> }
);


export const CollapsibleSectionFieldsFragmentDoc = `
    fragment CollapsibleSectionFields on CollapsibleSection {
  title
  content {
    json
  }
}
    `;
export const CollectionFieldsFragmentDoc = `
    fragment CollectionFields on CollectionCollection {
  total
  items {
    sys {
      id
    }
    collectionName
    collectionType
    description
    newBaseImage {
      url
      title
      width
      height
    }
    products
    slug
    baseImage
    exactMatches
    roomType
    roomStyle
    colors
    designTipsListCollection(limit: 12) {
      items {
        ...CollapsibleSectionFields
      }
    }
    designer {
      sys {
        id
      }
      name
    }
    designTipsTitle
    designPicksTitle
    photographer
    __typename
  }
}
    `;
export const CollectionCollectionDocument = `
    query collectionCollection($slug: String, $preview: Boolean) {
  collectionCollection(where: {slug: $slug}, preview: $preview, limit: 1) {
    ...CollectionFields
  }
}
    ${CollectionFieldsFragmentDoc}
${CollapsibleSectionFieldsFragmentDoc}`;

export const useCollectionCollectionQuery = <
      TData = CollectionCollectionQuery,
      TError = unknown
    >(
      variables?: CollectionCollectionQueryVariables,
      options?: Omit<UseQueryOptions<CollectionCollectionQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<CollectionCollectionQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<CollectionCollectionQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['collectionCollection'] : ['collectionCollection', variables],
    queryFn: graphqlFetcher<CollectionCollectionQuery, CollectionCollectionQueryVariables>(CollectionCollectionDocument, variables),
    ...options
  }
    )};

useCollectionCollectionQuery.getKey = (variables?: CollectionCollectionQueryVariables) => variables === undefined ? ['collectionCollection'] : ['collectionCollection', variables];


useCollectionCollectionQuery.fetcher = (variables?: CollectionCollectionQueryVariables, options?: RequestInit['headers']) => graphqlFetcher<CollectionCollectionQuery, CollectionCollectionQueryVariables>(CollectionCollectionDocument, variables, options);

export const CollectionTypeDocument = `
    query collectionType($slug: String, $preview: Boolean) {
  collectionCollection(where: {slug: $slug}, preview: $preview, limit: 1) {
    items {
      collectionType
    }
  }
}
    `;

export const useCollectionTypeQuery = <
      TData = CollectionTypeQuery,
      TError = unknown
    >(
      variables?: CollectionTypeQueryVariables,
      options?: Omit<UseQueryOptions<CollectionTypeQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<CollectionTypeQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<CollectionTypeQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['collectionType'] : ['collectionType', variables],
    queryFn: graphqlFetcher<CollectionTypeQuery, CollectionTypeQueryVariables>(CollectionTypeDocument, variables),
    ...options
  }
    )};

useCollectionTypeQuery.getKey = (variables?: CollectionTypeQueryVariables) => variables === undefined ? ['collectionType'] : ['collectionType', variables];


useCollectionTypeQuery.fetcher = (variables?: CollectionTypeQueryVariables, options?: RequestInit['headers']) => graphqlFetcher<CollectionTypeQuery, CollectionTypeQueryVariables>(CollectionTypeDocument, variables, options);

export const CollectionCollectionSeoDocument = `
    query collectionCollectionSeo($slug: String) {
  collectionCollection(where: {slug: $slug}, limit: 1) {
    items {
      collectionName
      description
      collectionType
      contentfulMetadata {
        tags {
          name
        }
      }
      newBaseImage {
        url
        title
        width
        height
      }
      products
      seo {
        ...SeoMetaData
      }
    }
  }
}
    ${SeoMetaDataFragmentDoc}`;

export const useCollectionCollectionSeoQuery = <
      TData = CollectionCollectionSeoQuery,
      TError = unknown
    >(
      variables?: CollectionCollectionSeoQueryVariables,
      options?: Omit<UseQueryOptions<CollectionCollectionSeoQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<CollectionCollectionSeoQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<CollectionCollectionSeoQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['collectionCollectionSeo'] : ['collectionCollectionSeo', variables],
    queryFn: graphqlFetcher<CollectionCollectionSeoQuery, CollectionCollectionSeoQueryVariables>(CollectionCollectionSeoDocument, variables),
    ...options
  }
    )};

useCollectionCollectionSeoQuery.getKey = (variables?: CollectionCollectionSeoQueryVariables) => variables === undefined ? ['collectionCollectionSeo'] : ['collectionCollectionSeo', variables];


useCollectionCollectionSeoQuery.fetcher = (variables?: CollectionCollectionSeoQueryVariables, options?: RequestInit['headers']) => graphqlFetcher<CollectionCollectionSeoQuery, CollectionCollectionSeoQueryVariables>(CollectionCollectionSeoDocument, variables, options);

export const CollectionSitemapDocument = `
    query collectionSitemap($skip: Int, $limit: Int) {
  collectionCollection(skip: $skip, limit: $limit) {
    total
    items {
      slug
      publishedDate
    }
  }
}
    `;

export const useCollectionSitemapQuery = <
      TData = CollectionSitemapQuery,
      TError = unknown
    >(
      variables?: CollectionSitemapQueryVariables,
      options?: Omit<UseQueryOptions<CollectionSitemapQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<CollectionSitemapQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<CollectionSitemapQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['collectionSitemap'] : ['collectionSitemap', variables],
    queryFn: graphqlFetcher<CollectionSitemapQuery, CollectionSitemapQueryVariables>(CollectionSitemapDocument, variables),
    ...options
  }
    )};

useCollectionSitemapQuery.getKey = (variables?: CollectionSitemapQueryVariables) => variables === undefined ? ['collectionSitemap'] : ['collectionSitemap', variables];


useCollectionSitemapQuery.fetcher = (variables?: CollectionSitemapQueryVariables, options?: RequestInit['headers']) => graphqlFetcher<CollectionSitemapQuery, CollectionSitemapQueryVariables>(CollectionSitemapDocument, variables, options);

export const PdpCollectionWithSkusDocument = `
    query pdpCollectionWithSkus($skus: [String]) {
  collectionCollection(where: {sku_contains_some: $skus}) {
    items {
      collectionName
      slug
      newBaseImage {
        url
        title
        width
        height
      }
      products
    }
  }
}
    `;

export const usePdpCollectionWithSkusQuery = <
      TData = PdpCollectionWithSkusQuery,
      TError = unknown
    >(
      variables?: PdpCollectionWithSkusQueryVariables,
      options?: Omit<UseQueryOptions<PdpCollectionWithSkusQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<PdpCollectionWithSkusQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<PdpCollectionWithSkusQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['pdpCollectionWithSkus'] : ['pdpCollectionWithSkus', variables],
    queryFn: graphqlFetcher<PdpCollectionWithSkusQuery, PdpCollectionWithSkusQueryVariables>(PdpCollectionWithSkusDocument, variables),
    ...options
  }
    )};

usePdpCollectionWithSkusQuery.getKey = (variables?: PdpCollectionWithSkusQueryVariables) => variables === undefined ? ['pdpCollectionWithSkus'] : ['pdpCollectionWithSkus', variables];


usePdpCollectionWithSkusQuery.fetcher = (variables?: PdpCollectionWithSkusQueryVariables, options?: RequestInit['headers']) => graphqlFetcher<PdpCollectionWithSkusQuery, PdpCollectionWithSkusQueryVariables>(PdpCollectionWithSkusDocument, variables, options);
